module.exports = __webpack_public_path__ + "img/add-nega.ed7664a0.png";